import { IAnalyticsInitialState } from './types';

const initialState: IAnalyticsInitialState = {
  // Add initial values as needed
};

export default initialState;
